import type { EmojiEntry, Segment } from "./types";

let entries: EmojiEntry[] = [];
let bySlug = new Map<string, EmojiEntry>();

export async function loadEmoji() {
  const res = await fetch("/assets/openmoji.tsv");
  const tsv = await res.text();
  entries = tsv
    .trim()
    .split("\n")
    .map((line) => {
      const [slug, hex, annotation, group, tags] = line.split("\t");
      return { slug, hex, annotation, group: group ?? "", tags: tags ?? "" };
    });
  bySlug = new Map(entries.map((e) => [e.slug, e]));
}

export function allEmoji(): EmojiEntry[] {
  return entries;
}

export function findEmoji(slug: string): EmojiEntry | undefined {
  return bySlug.get(slug);
}

export function emojiUrl(hex: string): string {
  return `/assets/openmoji-svg-black/${hex}.svg`;
}

const TOKEN = /:([a-z0-9_-]+):/g;

export function parseSegments(text: string): Segment[] {
  const segs: Segment[] = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN)) {
    if (m.index! > last) segs.push({ kind: "text", value: text.slice(last, m.index) });
    const slug = m[1].replace(/-/g, "_");
    const e = bySlug.get(slug);
    if (e) segs.push({ kind: "emoji", hex: e.hex, slug: e.slug });
    else segs.push({ kind: "text", value: m[0] });
    last = m.index! + m[0].length;
  }
  if (last < text.length) segs.push({ kind: "text", value: text.slice(last) });
  return segs;
}
